import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { format } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import YouTube from "react-youtube";
import { FaFacebookF } from "react-icons/fa";

const Video = () => {
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [highlights, setHighlights] = useState([]);
  const { slugUrl } = useParams();
  const opts = {
    width: "100%",
    height: "666",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://api-ls.cdnokvip.com/api/get-highlights?current=1&pageSize=120`
        );
        const data = await response.json();

        const foundVideo = data.value.data.find(
          (item) => item.slugUrl === slugUrl
        );
        setVideo(foundVideo);
        setHighlights(data.value.data);
        console.log(data.value.data);
        setLoading(false);
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchData();
    document.cookie = "cookieName=someValue; SameSite=None; Secure";
  }, [slugUrl]);

  if (loading)
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div role="status">
          <svg
            aria-hidden="true"
            className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#ffd325]"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  if (!video) return <div>Không tìm thấy video.</div>;

  return (
    <div className="max-w-[1390px] mx-auto px-2">
      <div>
        <div className="video bg-[#131314] p-4">
          <h1 className="text-[#F2F3F3] !text-[16px] md:!text-[24px] font-bold pb-3 uppercase">
            {`Xem lại trận đấu ${video?.title}`}
          </h1>
          <div>
            <div className="flex justify-between items-center gap-2">
              <div className="iframe-highlight w-full ">
                <YouTube videoId={video?.videoUrl.split("=")[1]} opts={opts} />
                <div className="bg-[#1170FF] inline-block mt-3">
                  <Link className="flex items-center text-[15px] p-2" to={""}>
                    <FaFacebookF /> Chia sẻ
                  </Link>
                </div>
                <span className="text-[11px] italic ms-2">
                  Chia sẻ để xem không giật lag !!!
                </span>
              </div>
              {/* <div className="w-[30%] iframe-chat">
                <iframe
                  src="https://embed.luongson.chat/embed-chat/:matchId"
                  height="100%"
                  width="100%"
                  scrolling="auto"
                  border="0"
                  frameborder="0"
                  title="Tỷ lệ kèo"
                ></iframe>
                <div className="flex items-center mt-3">
                  <Link
                    className="bg-[#2A3038] text-center text-[15px] text-[#AFB4BA] w-1/2 p-2"
                    to={""}
                  >
                    Kênh chung
                  </Link>
                  <Link
                    className="bg-[#E19A00] text-center w-1/2 text-[15px] text-[#fff] p-2 "
                    to={""}
                  >
                    Tắt chát
                  </Link>
                </div>
              </div> */}
            </div>
            <h2 className="text-[#F2F3F3] text-center mt-3 !text-[16px] md:!text-[24px] font-bold pb-3 ">
              {`Xem lại trận đấu ${video?.title} Ngày ${format(
                new Date(video?.createdDate),
                "dd/MM/yyyy"
              )}`}
            </h2>
          </div>
        </div>
        <div className="videolienquan bg-[#131314] p-4 mt-4">
          <div className="flex justify-start items-center gap-3 py-4">
            <div className=" w-[4px] h-[30px] bg-[#E19A00] rounded-[0_5px_5px_0]"></div>
            <h1 className="!text-[16px] md:!text-[24px] !text-[#FEA013] md:text-2xl font-bold py-2 uppercase">
              highlight khác
            </h1>
          </div>
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 pb-4">
            {highlights?.slice(0, 12).map((item, index) => (
              <li key={index}>
                <Link
                  to={`/${item?.slugUrl}`}
                  className="flex flex-row md:flex-col"
                >
                  <div className="relative">
                    <img
                      className="w-full h-[110px] md:h-[212px] xl:h-[280px]"
                      src={item?.imageUrl}
                      alt={item?.title}
                    />
                    <div className="absolute bottom-3 left-2 md:left-4 w-[24px] h-[24px] bg-white  text-[#921b71] hover:scale-110  rounded-[50%] flex justify-center items-center">
                      <FontAwesomeIcon
                        className="  w-[10px] h-[10px]"
                        icon={faPlay}
                      />
                    </div>
                  </div>
                  <div className="w-full  pt-6 px-4 ">
                    <h3 className="overflow-hidden line-clamp-2 text-base text-[#F2F3F3] !text-[15px] md:!text-[20px] font-bold">
                      {item?.title}
                    </h3>

                    {/* <p className="text-[14px] font-normal text-[#F2F3F3] mt-2">
                      {`Ngày ${format(
                        new Date(item?.createdDate),
                        "dd-MM-yyyy"
                      )} `}
                    </p> */}
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Video;
